import React from 'react';

/**
 * APEX v7.3 — Tabs Bar
 *
 * Barre de navigation principale entre tabs (Dashboard / Session / Analytics...).
 * Style "underline" gradient cyan→fuchsia pour l'actif.
 *
 * Props :
 *   - tabs       : array de { id, label, icon (component) }
 *   - activeTab  : id du tab actif
 *   - onChange   : (tabId) => void
 *
 * Extracted from App.jsx in v7.3 (refactor wave 1).
 */
export default function TabsBar({ tabs = [], activeTab, onChange }) {
  return (
    <div className="flex gap-1 mb-6 md:mb-8 border-b border-zinc-900 overflow-x-auto -mx-3 md:mx-0 px-3 md:px-0 scrollbar-thin">
      {tabs.map(tab => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`
              px-3 md:px-5 py-2.5 md:py-3
              text-[10px] md:text-xs tracking-[0.15em] md:tracking-[0.2em]
              font-bold uppercase transition border-b-2
              flex items-center gap-1.5 md:gap-2 whitespace-nowrap
              ${isActive ? 'border-transparent text-white' : 'border-transparent text-zinc-500 hover:text-zinc-300'}
            `}
            style={isActive ? { borderImage: 'linear-gradient(to right, #22d3ee, #e879f9) 1' } : {}}
          >
            {Icon && <Icon size={13} className={isActive ? 'text-cyan-400' : ''} />}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
